import { jsx } from 'react/jsx-runtime';
import 'react';

const MediumMenuUp = ({ testId, className })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.18158 9.07317L7.52107 6.16005C7.76439 5.94646 8.23547 5.94703 8.47811 6.15948L11.819 9.07317C11.9994 9.23111 12.0508 9.4638 11.9467 9.66839C11.8426 9.87017 11.604 10 11.3404 10H4.6601C4.39583 10 4.15793 9.87017 4.05249 9.66614C3.94976 9.4638 4.00045 9.23111 4.18158 9.07317Z",
            fill: "currentColor"
        })
    });
};

export { MediumMenuUp as default };
